import React, { useEffect, useState } from "react"

import Paper from "@material-ui/core/Paper"
import Container from "@material-ui/core/Container"
import Grid from "@material-ui/core/Grid"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography";
import {
	MuiPickersUtilsProvider,
	KeyboardDatePicker,
} from '@material-ui/pickers';
import {
	CircularProgress
} from "@material-ui/core";
import DateFnsUtils from '@date-io/date-fns';
import Box from '@material-ui/core/Box';
import moment from 'moment-timezone';
import IconButton from "@material-ui/core/IconButton";
import SyncIcon from '@material-ui/icons/Sync';
import { green } from "@material-ui/core/colors";
import { useHistory } from "react-router-dom";
import { format, parseISO } from "date-fns";
import Chip from '@material-ui/core/Chip';
import Badge from '@material-ui/core/Badge';
//import useTickets from "../../hooks/useTickets"

//import { AuthContext } from "../../context/Auth/AuthContext";

import { i18n } from "../../translate/i18n";

import Chart from "./Chart"
import api from "../../services/api";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	fixedHeightPaper: {
		padding: theme.spacing(2),
		display: "flex",
		overflow: "auto",
		flexDirection: "column",
		height: 240,
	},
	customFixedHeightPaper: {
		padding: theme.spacing(2),
		display: "flex",
		overflow: "auto",
		flexDirection: "column",
		height: 140,
	},
	customFixedHeightPaperLg: {
		padding: theme.spacing(2),
		display: "flex",
		overflow: "auto",
		flexDirection: "column",
		height: "100%",
	},
	circleLoading: {
		color: green[500],
		position: "absolute",
		opacity: "70%",
		top: 0,
		left: "50%",
		marginTop: 50,
	},
}))

const Dashboard = () => {

	const classes = useStyles()
	const history = useHistory();
	const date = moment();
	//const { user } = useContext(AuthContext);
	//const [userQueueIds, setUserQueueIds] = useState([]);
	const [data, setData] = useState([]);
	const [selectedDateInicial, setSelectedDateInicial] = useState(date.tz('America/Sao_Paulo'));
	const [selectedDateFinal, setSelectedDateFinal] = useState(date.tz('America/Sao_Paulo'));
	const [loading, setLoading] = useState(false);


	useEffect(() => {

		fetchDashboard();

		/*
		if (user?.id && user.queues && user.queues.length > 0) {
			setUserQueueIds(user.queues.map(q => q.id));
		}
		*/

		// eslint-disable-next-line
	}, []);

	/*
const GetTickets = (status, showAll, withUnreadMessages) => {

	const { count } = useTickets({
		status: status,
		showAll: showAll,
		withUnreadMessages: withUnreadMessages,
		queueIds: JSON.stringify(userQueueIds)
	});
	return count;
}*/

	const fetchDashboard = async () => {
		try {

			let searchParam = {
				dataInicial: moment(selectedDateInicial).format('YYYY-MM-DD'),
				dataFinal: moment(selectedDateFinal).format('YYYY-MM-DD')
			}
			setLoading(true);
			console.log('searchParam ', searchParam);

			const { data } = await api.get("/dashboard/", {
				params: { searchParam },
			});

			console.log(data);
			setData(data);
			setLoading(false);
		} catch (err) {
			console.log(err);
		}
	};

	const SyncData = () => {
		fetchDashboard();
	}

	const HtmlTooltip = withStyles(() => ({
		tooltip: {
			backgroundColor: '#f5f5f9',
			color: 'rgba(0, 0, 0, 0.87)',
			maxWidth: 220,
			border: '1px solid #dadde9',
		},
	}))(Tooltip);

	const GetAtendimentos = (status) => {

		let array = [];

		for (let index = 0; index < data?.atendimentos?.length; index++) {
			const element1 = data?.atendimentos[index];

			let flag = true;

			for (let index = 0; index < array.length; index++) {
				const element2 = array[index];

				if (element1['contact_id'] === element2.contact_id) {
					flag = false;
					break;
				}

			}

			if (flag) {

				if (element1['ticket_status'] === status) {
					const obj = {
						contact_id: element1['contact_id'],
					}

					array.push(obj);
				}
			}
		}
		return array.length;
	}

	const openWindowTicket = () => {
		history.push(`/tickets`);
	}

	const ClientesNoSuporte = () => {

		let array = [];

		for (let index = 0; index < data?.atendimentos?.length; index++) {
			const element1 = data?.atendimentos[index];

			let flag = true;

			for (let index = 0; index < array.length; index++) {
				const element2 = array[index];

				if (element1['contact_id'] === element2.contact_id && element1['fromMe'] === 0) {
					element2.cont = parseInt(element2.cont) + parseInt(element1['n_message']);

					if(moment(element2.dataMax) < moment(element1['dataMax'])){
						element2.dataMax = element1['dataMax']
					}
					if(moment(element2.dataMin) > moment(element1['dataMin'])){
						element2.dataMin = element1['dataMin']
					}
					flag = false;
					break;
				}

			}

			if (flag) {

				if (element1['fromMe'] === 0 ) {
					const obj = {
						contact_id: element1['contact_id'],
						contact_name: element1['contact_name'],
						dataMin: element1['dataMin'],
						dataMax: element1['dataMax'],
						cont: element1['n_message']
					}

					array.push(obj);
				}
			}
		}
		return array.sort(mycomparator);

	}

	const ClienteAtendente = () => {


		let array = [];
		for (let index = 0; index < data?.atendimentos?.length; index++) {
			const element1 = data?.atendimentos[index];

			let flag = true;

			for (let index = 0; index < array.length; index++) {
				const element2 = array[index];

				if (element1['contact_id'] === element2.contact_id && element1['ticket_status'] === 'open') {
					flag = false;
				}
			}

			if (flag) {

				if (element1['contact_id'] && element1['ticket_status'] === 'open') {
					const obj = {
						contact_id: element1['contact_id'],
						contact_name: element1['contact_name']
					}

					array.push(obj);
				}
			}
		}
		return array.sort(mycomparator);
	}



	const GetAnalistasPorCliente = () => {



		let array = [];
		for (let index = 0; index < data?.atendimentos?.length; index++) {
			const element1 = data?.atendimentos[index];

			let flag = true;

			for (let index = 0; index < array.length; index++) {
				const element2 = array[index];

				if (element1['nome_usuario'] === element2.nome_usuario && parseInt(element1['n_message']) > 0) {

					let flag2 = true;
					for (let index = 0; index < element2.clientes.length; index++) {
						const element3 = element2.clientes[index];

						if(element3.contact_id === element1['contact_id']){
							element3.cont = parseInt(element3.cont) + parseInt(element1['n_message']);
							flag2 = false;
							break;
						}		
					}

					if(flag2){
						element2.clientes.push({
							contact_id: element1['contact_id'],
							contact_name: element1['contact_name'],
							cont: element1['n_message']
						})
					}

					flag = false;
				}	
			}

			if (flag) {

				if (element1['nome_usuario'] && parseInt(element1['n_message']) > 0) {
					const obj = {
						nome_usuario: element1['nome_usuario'],
						clientes: [
							{
								contact_id: element1['contact_id'],
								contact_name: element1['contact_name'],
								cont: element1['n_message']
							}
						]
					}

					array.push(obj);
				}
			}
		}
		return array.sort(mycomparator);
	}

	function mycomparator(a, b) {
		return parseInt(b.cont) - parseInt(a.cont);
	}

	return (
		<div>
			<Container maxWidth="lg" className={classes.container}>

				{loading && (
					<div>
						<CircularProgress className={classes.circleLoading} />
					</div>
				)}
				<Box sx={{ display: 'flex', flexWrap: 'wrap', flex: 12 }}>
					<MuiPickersUtilsProvider utils={DateFnsUtils} >
						<KeyboardDatePicker
							disableToolbar
							inputVariant="outlined"
							format="dd/MM/yyyy"
							margin="dense"
							id="date-picker-inline"
							label="Date Inicial"
							value={selectedDateInicial}
							maxDate={selectedDateFinal}
							onChange={(date) => { setSelectedDateInicial(date) }}
							KeyboardButtonProps={{
								'aria-label': 'change date',
							}}

							style={{ minWidth: 200, flex: 2, marginRight: 10 }}
						/>
						<KeyboardDatePicker
							disableToolbar
							inputVariant="outlined"
							format="dd/MM/yyyy"
							margin="dense"
							id="date-picker-inline"
							label="Date Final"
							value={selectedDateFinal}
							minDate={selectedDateInicial}
							onChange={(date) => { setSelectedDateFinal(date) }}
							KeyboardButtonProps={{
								'aria-label': 'change date',
							}}

							style={{ minWidth: 200, flex: 2, marginRight: 10 }}
						/>
					</MuiPickersUtilsProvider>
					<IconButton onClick={() => SyncData()}>
						<SyncIcon color="secondary" />
					</IconButton>
				</Box>
				<Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', flex: 12 }}>
					<Grid item style={{ minWidth: 200, flex: 2, marginRight: 10 }}>
						<Paper
							className={classes.customFixedHeightPaper}
							style={{ overflow: "hidden" }}

						>

							<IconButton onClick={() => { openWindowTicket() }}>
								<Typography style={{fontSize: 16}} component="h5" variant="h5" color="primary" paragraph align="center">
									{i18n.t("dashboard.messages.inAttendance.title")}
								</Typography>
							</IconButton>
							<Grid item>
								<Typography component="h1" variant="h4" align="center">
									{GetAtendimentos('open')}
								</Typography>
							</Grid>
						</Paper>
					</Grid>
					<Grid item style={{ minWidth: 200, flex: 2, marginRight: 10 }}>
						<Paper className={classes.customFixedHeightPaper} style={{ overflow: "hidden" }}>
							<IconButton onClick={() => { openWindowTicket() }}>
								<Typography style={{fontSize: 16}} component="h3" variant="h6" color="primary" paragraph align="center">
									{i18n.t("dashboard.messages.waiting.title")}
								</Typography>
							</IconButton>
							<Grid item>
								<Typography component="h1" variant="h4" align="center">
									{GetAtendimentos('pending')}
								</Typography>
							</Grid>
						</Paper>
					</Grid>
					<Grid item style={{ minWidth: 200, flex: 2, marginRight: 10 }}>
						<Paper className={classes.customFixedHeightPaper} style={{ overflow: "hidden" }}>
							<Typography component="h3" variant="h6" color="primary" paragraph align="center">
								{i18n.t("dashboard.messages.closed.title")}
							</Typography>
							<Grid item>
								<Typography component="h1" variant="h4" align="center">
									{GetAtendimentos("closed")}
								</Typography>
							</Grid>
						</Paper>
					</Grid>
					<Grid item xs={12}>
						<Paper className={classes.fixedHeightPaper}>
							<Chart data={ClientesNoSuporte()} />
						</Paper>
					</Grid>

					<Grid item style={{ minWidth: 200, flex: 2, marginRight: 10 }}>
						<Paper >
							<Typography component="h3" variant="h6" color="primary" paragraph align="center">
								Analistas por Cliente
							</Typography>
							<List>
								{GetAnalistasPorCliente()?.map((item, index) => (
									<React.Fragment key={item.nome_usuario || index}>
										<ListItem key={item.id} >

											 <HtmlTooltip
												title={
													<React.Fragment>

														{item.clientes.map((value, index)=>(

															<Badge key={index} badgeContent={value.cont} color="primary" overlap="rectangular">
																<Chip
																	size="small"
																	label={value.contact_name}
																	clickable
																	
																	/>
															</Badge>
														))}
													</React.Fragment>
												}
												enterTouchDelay={50}
												leaveTouchDelay={20000}
											>
												<Badge badgeContent={item.clientes.length} color="secondary" overlap="rectangular">
													<Chip
														size="small"
														label={item.nome_usuario}
														clickable
														color="primary"
														/>
												</Badge>
											</HtmlTooltip>
										</ListItem>

										<Divider component="li" />
									</React.Fragment>
								))}

							</List>

						</Paper>
					</Grid>

					<Grid item style={{ minWidth: 200, flex: 2, marginRight: 10 }}>
						<Paper >
							<Typography component="h3" variant="h6" color="primary" paragraph align="center">
								Clientes em Atendimentos
							</Typography>
							<List>
								{ClienteAtendente()?.map((item) => (
									<ListItem key={item.contact_id}>
										<Chip
											size="small"
											label={item.contact_name}
											/>
	
									</ListItem>
								))}

							</List>

						</Paper>
					</Grid>

					<Grid item style={{ minWidth: 200, flex: 2, marginRight: 10 }}>
						<Paper >
							<Typography component="h3" variant="h6" color="primary" paragraph align="center">
								Clientes e Total Msn Enviadas
							</Typography>
							<List>
								{ClientesNoSuporte()?.map((item) => (
									<React.Fragment key={item.contact_id}>
										<ListItem >
											<Badge badgeContent={item.cont} color="error" overlap="rectangular">
												<Chip
													size="small"
													label={item.contact_name}
													clickable
													color="primary"
													/>
											</Badge>
										</ListItem>
										<ListItemText secondary={"Msg I: "+ format(parseISO(item.dataMin), "HH:mm:ss") + " | Msg F: " + format(parseISO(item.dataMax), "HH:mm:ss")} 
											primaryTypographyProps={{ 
												fontSize: 9
											}}
										/>
										<Divider component="li" />
									</React.Fragment>
									
								))}

							</List>

						</Paper>
					</Grid>
				</Grid>
			</Container>
		</div>
	)
}

export default Dashboard